export enum SubscriptionNotificationTrigger {
  PaymentRequiredAction = 'payment_required_action',
  SubscriptionEnd = 'subscription_end',
}

export enum BroadcastMessageTrigger {
  Announcement = 'announcement',
}

export enum NextContactReminderTrigger {
  Reminder = 'reminder',
}

export enum NotificationStatus {
  READ = 'read',
  UNREAD = 'unread',
}

export enum NotificationType {
  SubscriptionInfo = 'subscription_info',
  BroadcastMessage = 'broadcast_message',
  NextContactReminder = 'next_contact_reminder',
}

export type TypeTriggerMap = {
  [NotificationType.SubscriptionInfo]: SubscriptionNotificationTrigger;
  [NotificationType.BroadcastMessage]: BroadcastMessageTrigger;
  [NotificationType.NextContactReminder]: NextContactReminderTrigger;
};

export interface NotificationDocument<T = object> {
  type: NotificationType;
  eventDate: string;
  data?: T;
  status: NotificationStatus;
  timestamp: Date;
  eventTimestamp: Date;
  connectedClientEmail?: string | null;
}

export interface GenericNotification<
  Type extends NotificationType = NotificationType,
  Trigger extends TypeTriggerMap[Type] = TypeTriggerMap[Type],
  Data = { [key: string]: any },
> extends NotificationDocument {
  type: Type;
  data: {
    action: Trigger;
    payload: Data;
  };
}

export type WithId<T extends object> = T & { id: string };
